import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

const AuthSuccess = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      localStorage.setItem('token', token);
      const redirectTo = searchParams.get('redirectTo');
      
      checkAuth().then((userData) => {
        // Wrapper Support: If this is a popup, notify the opener
        if (window.opener && window.opener !== window) {
          window.opener.postMessage({
            type: 'VIEWGATE_AUTH_SUCCESS',
            token: token,
            user: userData,
            role: userData?.role || 'dev'
          }, '*');
          // Small delay to ensure message is sent before closing
          setTimeout(() => {
             window.close();
          }, 500);
          return;
        }

        navigate(redirectTo || '/');
      });
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center text-primary">
       <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <span className="font-bold tracking-widest uppercase text-xs">{t('authenticating')}</span>
       </div>
    </div>
  );
};

export default AuthSuccess;
